(function () {
  'use strict';

  var SVG_LIGHTNING = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.426 13.006c-.057 0-.057 0-.115-.006-.633-.07-1.095-.698-1.032-1.402l.61-7.445C7.95 3.5 8.445 3 9.037 3H13.5c.128 0 .254.023.375.07.602.23.922.958.715 1.627L13.1 8.802h2.748c.203 0 .402.06.578.173.55.356.738 1.14.418 1.75-.414.816-4.58 7.816-5.926 10.075-.107.18-.381.092-.37-.117L11 13l-2.573.006z" stroke="#070707" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_SPARKLE   = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M11.456 2.665a.6.6 0 0 1 1.088 0l2.864 6.137a.6.6 0 0 0 .29.29l6.137 2.864a.6.6 0 0 1 0 1.088l-6.137 2.864a.6.6 0 0 0-.29.29l-2.864 6.137a.6.6 0 0 1-1.088 0l-2.864-6.137a.6.6 0 0 0-.29-.29l-6.137-2.864a.6.6 0 0 1 0-1.088l6.137-2.864a.6.6 0 0 0 .29-.29l2.864-6.137z" stroke="#070707" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_DROPLET   = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 14c0-4.418-8-12-8-12S4 9.582 4 14a8 8 0 1 0 16 0z" stroke="#070707" stroke-width="1.3"/></svg>';

  var ICON_MAP = {
    icon_lightning: SVG_LIGHTNING,
    icon_sparkle:   SVG_SPARKLE,
    icon_droplet:   SVG_DROPLET
  };

  function parseData() {
    var el = document.querySelector('script[id^="cadence-usp-data-"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function isMobile() { return window.innerWidth <= 749; }

  /* ============================================================
     USP COLUMN INJECTION
  ============================================================ */

  function initUSPColumn(cards) {
    var firstSlide    = document.querySelector('.product__slides .product__slide');
    var productImages = document.querySelector('product-images');
    var slidesHolder  = document.querySelector('.product__slides');
    if (!firstSlide || !productImages || !slidesHolder) return;

    var html = '';
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      html += '<div class="cusp-card">';
      if (c.type === 'stat') {
        html += '<span class="cusp-stat">' + c.stat + '</span>';
      } else if (c.icon_url) {
        html += '<span class="cusp-icon-wrap"><img src="' + c.icon_url + '" alt="" width="24" height="24" loading="lazy"></span>';
      } else {
        html += '<span class="cusp-icon-wrap">' + (ICON_MAP[c.type] || '') + '</span>';
      }
      html += '<span class="cusp-label">' + c.label + '</span>';
      html += '</div>';
    }

    var uspCol = document.createElement('div');
    uspCol.id = 'cadence-usp-col';
    uspCol.setAttribute('aria-hidden', 'true');
    uspCol.innerHTML = html;

    firstSlide.classList.add('cadence-usp-slide');
    slidesHolder.classList.add('cadence-usp-holder');
    productImages.classList.add('cadence-usp-images');
    firstSlide.appendChild(uspCol);

    /* Aspect ratio */
    var photoEl  = firstSlide.querySelector('.product__photo');
    var figureEl = firstSlide.querySelector('.product__photo figure');
    if (photoEl)  photoEl.style.setProperty('--aspect-ratio', '1.125');
    if (figureEl) figureEl.style.setProperty('--aspect-ratio', '1.125');

    /* Height sync */
    var MAX_H = 600, lastH = 0, resizeTimer;

    function adjustHeight() {
      if (!photoEl) return;
      var rawH = photoEl.offsetHeight;
      if (rawH === lastH) return;
      lastH = rawH;
      var h = Math.min(rawH, MAX_H);
      productImages.style.setProperty('--height', h + 'px');
      slidesHolder.style.setProperty('--height', h + 'px');
      if (window.innerWidth <= 749) {
        uspCol.style.height = '';
        uspCol.style.paddingTop = '';
        uspCol.style.paddingBottom = '';
        return;
      }
      uspCol.style.height = h + 'px';
      uspCol.style.paddingTop = '0px';
      uspCol.style.paddingBottom = '0px';
    }

    requestAnimationFrame(adjustHeight);
    window.addEventListener('load', adjustHeight);
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(adjustHeight, 120);
    });

    /* Visibility: fade USP col when not on first slide */
    function updateVisibility() {
      uspCol.style.opacity = firstSlide.classList.contains('media--active') ? '1' : '0';
    }

    var allSlides = document.querySelectorAll('.product__slides .product__slide');
    var slideObserver = new MutationObserver(updateVisibility);
    for (var s = 0; s < allSlides.length; s++) {
      if (s > 0) slideObserver.observe(allSlides[s], { attributes: true, attributeFilter: ['class'] });
    }

    var navEls = document.querySelectorAll('.slider__button--prev, .slider__button--next, .product__thumb__link');
    for (var n = 0; n < navEls.length; n++) {
      navEls[n].addEventListener('click', function () { setTimeout(updateVisibility, 80); });
    }

    updateVisibility();
  }

  /* ============================================================
     MOBILE REORDER — title + price above images, reviews below breadcrumbs
  ============================================================ */

  function initMobileReorder() {
    var headPH  = null; /* placeholder comment nodes */
    var pricePH = null;
    var yotpoPH = null;
    var layoutDone = false;
    var resizeTimer, yotpoRetry;

    function el(sel) { return document.querySelector(sel); }

    function getPage()   { return el('.product__page'); }
    function getHead()   { return el('.product__block.product__head.block-padding'); }
    function getImages() { return el('product-images'); }

    function getPriceRow() {
      return el('[data-spark="b2c-only"] .product__price-pack') ||
             el('[data-spark="b2c-only"] .product__price__wrap');
    }

    function getPriceBlock() {
      var r = getPriceRow();
      return r ? r.closest('[data-spark="b2c-only"]') : el('[data-spark="b2c-only"]');
    }

    function getYotpo() {
      return el('.product__block.product__head .yotpo.bottomLine') ||
             el('.yotpo-widget-clear.yotpo-bottom-line-scroll-panel .yotpo-sr-bottom-line-summary.yotpo-sr-bottom-line-button') ||
             el('.yotpo.bottomLine') ||
             el('[data-yotpo-element-id] .yotpo-bottom-line');
    }

    function ph(node) {
      /* insert a comment node before `node` and return it */
      var c = document.createComment('cadence-ph');
      node.parentNode.insertBefore(c, node);
      return c;
    }

    function insertAfterBreadcrumbs(yotpo) {
      var bc = el('.breadcrumbs.product__breadcrumbs');
      if (bc && bc.parentNode) {
        bc.parentNode.insertBefore(yotpo, bc.nextSibling);
      } else {
        var page = getPage(), head = getHead();
        if (page && head) page.insertBefore(yotpo, head);
      }
      yotpo.classList.add('cadence-mobile-reviews');
    }

    function ensurePlaceholders(head, price, yotpo) {
      if (!headPH  && head  && head.parentNode)  headPH  = ph(head);
      if (!pricePH && price && price.parentNode)  pricePH = ph(price);
      if (!yotpoPH && yotpo && yotpo.parentNode)  yotpoPH = ph(yotpo);
    }

    function restoreDesktop(head, price, yotpo) {
      if (headPH  && headPH.parentNode  && head)  headPH.parentNode.insertBefore(head, headPH.nextSibling);
      if (pricePH && pricePH.parentNode && price) pricePH.parentNode.insertBefore(price, pricePH.nextSibling);
      if (yotpoPH && yotpoPH.parentNode && yotpo) {
        yotpoPH.parentNode.insertBefore(yotpo, yotpoPH.nextSibling);
        yotpo.classList.remove('cadence-mobile-reviews');
      }
    }

    function moveBlocks() {
      var page  = getPage(),   head  = getHead();
      var price = getPriceBlock(), imgs = getImages();
      if (!page || !head || !price || !imgs) return false;

      ensurePlaceholders(head, price, getYotpo());

      if (isMobile()) {
        page.insertBefore(head, imgs);
        page.insertBefore(price, imgs);
        var yotpo = getYotpo();
        if (yotpo) insertAfterBreadcrumbs(yotpo);
      } else {
        restoreDesktop(head, price, getYotpo());
      }
      return true;
    }

    function applyPriceRow() {
      var priceRow = getPriceRow();
      var yotpo    = getYotpo();
      if (!priceRow) return false;

      /* Yotpo not yet rendered — wait for it */
      if (!yotpo || !yotpo.innerHTML.trim()) {
        waitForYotpo(applyPriceRow);
        return false;
      }

      ensurePlaceholders(getHead(), getPriceBlock(), yotpo);

      var priceEl  = priceRow.querySelector('.product__price');
      var packEl   = priceRow.querySelector('.product__pack-text');
      var priceOff = priceRow.querySelector('.product__price--off');
      if (!priceEl) return false;

      var leftCol = priceRow.querySelector('.cadence-price-left');
      if (!leftCol) {
        leftCol = document.createElement('div');
        leftCol.className = 'cadence-price-left';
        priceRow.insertBefore(leftCol, priceRow.firstChild);
      }
      if (!leftCol.contains(priceEl))              leftCol.appendChild(priceEl);
      if (packEl   && !leftCol.contains(packEl))   leftCol.appendChild(packEl);
      if (priceOff && !leftCol.contains(priceOff)) leftCol.appendChild(priceOff);

      /* Yotpo moves into price row on desktop only; mobile places it under breadcrumbs */
      if (!isMobile() && !priceRow.contains(yotpo)) priceRow.appendChild(yotpo);

      priceRow.classList.add('cadence-price-row');
      return true;
    }

    function waitForYotpo(cb) {
      var attempts = 0;
      function check() {
        var y = getYotpo();
        if (y && y.innerHTML.trim()) { clearTimeout(yotpoRetry); cb(); return; }
        if (++attempts >= 50) return;
        yotpoRetry = setTimeout(check, 100);
      }
      check();
    }

    function run() {
      if (layoutDone) return;
      var moved  = moveBlocks();
      var priced = applyPriceRow();
      if (moved && priced) layoutDone = true;
    }

    run();

    /* Watch for Yotpo async render */
    var yotpoObserver = new MutationObserver(function () {
      var y = getYotpo();
      if (y && y.innerHTML.trim()) {
        applyPriceRow();
        if (isMobile() && !document.querySelector('.cadence-mobile-reviews')) {
          insertAfterBreadcrumbs(y);
        }
        yotpoObserver.disconnect();
      }
    });
    yotpoObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { yotpoObserver.disconnect(); }, 10000);

    /* Resize — switch between mobile/desktop */
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) {
          layoutDone = false;
          run();
        } else {
          restoreDesktop(getHead(), getPriceBlock(), getYotpo());
          layoutDone = false;
          run();
        }
      }, 150);
    });
  }

  /* ============================================================
     YOTPO SCROLL — click star rating near heading → scroll to reviews
  ============================================================ */

  function initYotpoScroll() {
    var bound = false;

    function attach() {
      if (bound) return;
      var yotpo = document.querySelector('.yotpo.bottomLine') ||
                  document.querySelector('.yotpo-sr-bottom-line-summary') ||
                  document.querySelector('.yotpo-widget-clear.yotpo-bottom-line-scroll-panel');
      if (!yotpo || !yotpo.innerHTML.trim()) return;
      bound = true;
      yotpo.style.cursor = 'pointer';
      yotpo.addEventListener('click', function () {
        var target = document.querySelector('#yotpo-app') ||
                     document.querySelector('.yotpo-main-widget');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    attach();
    var obs = new MutationObserver(function () {
      attach();
      if (bound) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  /* ============================================================
     ENTRY POINT
  ============================================================ */

  function init() {
    var data = parseData();
    if (!data || !data.cards) return;

    var cards = data.cards.filter(function (c) { return c.type !== 'hidden' && c.type; });
    if (!cards.length) return;

    initUSPColumn(cards);
    initMobileReorder();
    initYotpoScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
